import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	max-width: 1420px;
	margin: 0 auto;
	color: ${CSSVars.white};
	text-align: center;
	position: relative;

	a {
		text-decoration: none;
		color: white;
	}

	p {
		color: ${CSSVars.primary500};
		font-weight: 600;
		font-size: ${CSSVars.fontSizeMD};
		text-transform: uppercase;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSizeXL};
		}
	}

	h2 {
		font-weight: 600;
		font-size: ${CSSVars.fontSize4XL};
		margin: 30px 0 50px;
		font-size: ${CSSVars.fontSize2XL};
		text-transform: capitalize;

		@media screen and (min-width: ${CSSVars.breakpointMD}) {
			font-size: ${CSSVars.fontSize4XL};
		}
	}

	.swiper-container {
		margin: 50px 20px 0;
		max-width: 1400px;
		position: relative;

		.item-wrapper {
			position: relative;
			background-color: ${CSSVars.gray600};
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			gap: 20px;
			padding: 30px;
			border-radius: 10px;
			transition: 0.2s;
			border: 1px solid #2a2e42;
			text-align: left;
			min-height: 325px;

			&:hover {
				border: 1px solid ${CSSVars.gray500};
			}

			img.platform {
				position: absolute;
				right: 30px;
				width: 100px;
				top: 30px;
				opacity: 0.5;
			}

			img.app {
				width: 65px;
				height: 65px;
				object-fit: cover;
				border-radius: 5px;
			}

			.content {
				h3 {
					font-weight: 500;
					font-size: 18px;
					line-height: 1.5;
					margin: 0;

					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					line-clamp: 2;
					-webkit-box-orient: vertical;
					margin-bottom: 15px;

					a {
						transition: 0.2s ease;
						&:hover {
							color: ${CSSVars.primary500};
						}
					}
				}

				p {
					margin: 0;
					font-weight: 300;
					font-size: 14px;
					line-height: 20px;
					color: ${CSSVars.white};
					text-transform: none;

					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					line-clamp: 3;
					-webkit-box-orient: vertical;
				}
			}

			a.btn {
				margin-top: 20px;
				border: 1px solid ${CSSVars.primary500};
				color: ${CSSVars.primary500};
				background-color: transparent;
				padding: 8px 25px;
				border-radius: 5px;
				font-size: ${CSSVars.fontSizeMD};
				cursor: pointer;
				transition: 0.2s;
				font-weight: 600;
				font-family: ${CSSVars.primaryFont};
				width: 100%;

				&:hover {
					border: 1px solid ${CSSVars.primary400};
					color: ${CSSVars.primary400};
				}
			}
		}
	}

	.arrow {
		position: absolute;
		z-index: 100;
		top: 67%;
		transform: translateY(-50%);
		display: none;

		@media screen and (min-width: ${CSSVars.breakpointXL}) {
			display: block;
		}

		.arrow-btn {
			cursor: pointer;
			padding: 0;
			border: none;
			background-color: transparent;

			&:hover {
				.icon {
					color: ${CSSVars.primary500};
				}
			}
		}

		.icon {
			font-size: 50px;
			color: black;
			opacity: 0.8;
			transition: 0.2s;
			color: ${CSSVars.gray500};

			&:hover {
				opacity: 1;
			}
		}

		&.arrow-left {
			left: -40px;
		}

		&.arrow-right {
			right: -40px;
		}
	}
`;
